(function () {
  let cleanupRunning = false;

  function cleanupGloboSSO() {
    if (cleanupRunning) return;
    cleanupRunning = true;

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {

        const parentGroups = cart.items
          .map(item => item.properties && item.properties._gpo_product_group)
          .filter(Boolean);

        const orphanItems = cart.items.filter(item => {
          const childGroup = item.properties && item.properties._gpo_parent_product_group;
          return childGroup && !parentGroups.includes(childGroup);
        });

        if (!orphanItems.length) {
          cleanupRunning = false;
          return;
        }

        // Verwijder orphan items in ÉÉN request (belangrijk!)
        const updates = {};
        orphanItems.forEach(item => {
          updates[item.key] = 0;
        });

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        }).then(() => {
          cleanupRunning = false;
        });

      })
      .catch(() => {
        cleanupRunning = false;
      });
  }

  // Prestige events
  document.addEventListener('cart:refresh', cleanupGloboSSO);
  document.addEventListener('cart:change', cleanupGloboSSO);

  // Fallback bij page load
  document.addEventListener('DOMContentLoaded', cleanupGloboSSO);
})();
